import { dashboardMockupData } from './DashboardMockup';
import { chatMockupData } from './ChatMockup';
import { notesMockupData } from './NotesMockup';
import { tasksMockupData } from './TasksMockup';
import { bookmarksMockupData } from './BookmarksMockup';
import { listsMockupData } from './ListsMockup';
import { moodboardMockupData } from './MoodboardMockup';
import { tableMockupData } from './TableMockup';
import { MockupItem } from './MockupItem';

// Export all mockup data in an array
export const MOCKUPS = [
  dashboardMockupData,
  chatMockupData,
  notesMockupData,
  tasksMockupData,
  listsMockupData,
  bookmarksMockupData, 
  moodboardMockupData,
  tableMockupData
];

// Export the MockupItem component
export { MockupItem };

// Export mockup utility components
export * from './MockupUtils';